/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("ImportsComponentCtrl", [
		"$scope", "$q", "toastr", "Utils", "$uibModal", "importConfigurations", "importConfiguration", "isAutomaticImport", "isNew",
		"OpenImportsService", "AdminClientsService",
		"$location", "$timeout", "SharedProperties", "targetNetworks", "AdminImportConfigurationService",
		function ($scope, $q, toastr, Utils, $uibModal, importConfigurations, importConfiguration, isAutomaticImport, isNew,
				  OpenImportsService, AdminClientsService,
				  $location, $timeout, SharedProperties, targetNetworks, AdminImportConfigurationService) {

			// Configuration commune
			$scope.data = {
				newImport: {},
				files: {},
				analysisCompleted: false,
				analysisLaunchTime: null,
				analysisJob: null,
				analysisData: {},
				importData: {},
				type: null,
				sncf: false,
				railUICprocessing: "false",
				automaticImportConfiguration: isAutomaticImport,
				isNew: isNew,
				importConfigurations: importConfigurations.data,
				importConfiguration: importConfiguration.data ? importConfiguration.data : {},
				isNewConfigurationUrl: true,
				isNewConfigurationFtp: true
			};

			$scope.status = {
				isFTPOpen: true,
				isURLOpen: false,
				isConfiguration: false,
				isConfigurationEdit: false
			};

			$scope.tripsTxtFields = [
				"route_id",
				"service_id",
				"trip_id",
				"trip_headsign",
				"trip_short_name",
				"direction_id",
				"block_id",
				"shape_id",
				"wheelchair_accessible",
				"bikes_allowed"
			];

			$scope.formData = {
				description: "",
				cleanMode: "",
				routeMerge: false,
				splitCharacter: "",
				ignoreCommercialPoints: false,
				linePrefixToRemove: "",
				importTargetRoutes: "",
				areaCentroidPrefixToRemove: "",
				stopAreaPrefixToRemove: "",
				quayIdPrefixToRemove: "",
				commercialPointPrefixToRemove: "",
				keepBoardingAlightingPossibility: "false",
				keepStopGeolocalisation: "false",
				distanceGeolocation: 200,
				removeParentStations: "false",
				keepStopNames: "true",
				importShapesFile: "true",
				updateStopAccessibility: "true",
				routesReorganization: false,
				routeSortOrder: "false",
				netexImportLayouts: "false",
				netexImportColors: "false",
				useTargetNetwork: false,
				targetNetwork: "",
				renameRoutesAfterMerge: false,
				generateMapMatching: "NONE",
				importFareFiles: false,
				targetNetworks: Object.hasOwn(targetNetworks, "data") ? targetNetworks.data.map(function(e) { return e.name; }) : [],
				recomputeStopPlacesLocation: true,
				allowNonStandardGtfs:false,
				fillMissingStopName: '',
				fillMissingCoordinates: '',
				overwriteLineInformation: true,
				allowGtfsFlex: false,
				isExternalRefField: false,
				externalRefField: "",
				isDriverControllerCodeField: false,
				driverControllerCodeField: "",
			};

			if ($scope.data.automaticImportConfiguration) {
				if ($scope.data.importConfiguration.importParameters === undefined || $scope.data.importConfiguration.importParameters.length === 0) {
					$scope.data.importConfiguration.importParameters = [];
					let importParameters = {};
					importParameters.importType = "GTFS";
					importParameters.generateMapMatching = "NONE";
					importParameters.railUICprocessing = false;
					$scope.data.importConfiguration.importParameters.push(importParameters);
				} else {
					$scope.formData = $scope.data.importConfiguration.importParameters[0];
					$scope.formData.targetNetworks = Object.hasOwn(targetNetworks, "data") ? targetNetworks.data.map(function(e) { return e.name; }) : []
					$scope.formData.cleanMode = $scope.data.importConfiguration.importParameters[0].importMode;
					$scope.formData.commercialPointPrefixToRemove = $scope.data.importConfiguration.importParameters[0].commercialPointPrefixToRemove;
					$scope.formData.keepBoardingAlightingPossibility = $scope.data.importConfiguration.importParameters[0].keepBoardingAlighting === true ? "true" : "false";
					$scope.formData.keepStopGeolocalisation = $scope.data.importConfiguration.importParameters[0].keepStopGeolocalisation === true ? "true" : "false";
					$scope.formData.removeParentStations = $scope.data.importConfiguration.importParameters[0].removeParentStations === true ? "true" : "false";
					$scope.formData.keepStopNames = $scope.data.importConfiguration.importParameters[0].keepStopNames === true ? "true" : "false";
					$scope.formData.importShapesFile = $scope.data.importConfiguration.importParameters[0].importShapesFile === true ? "true" : "false";
					$scope.formData.updateStopAccessibility = $scope.data.importConfiguration.importParameters[0].updateStopAccessibility === true ? "true" : "false";
					if (angular.isArray($scope.data.importConfiguration.importParameters[0].importTargetRoutes) && $scope.data.importConfiguration.importParameters[0].importTargetRoutes.length) {
						$scope.formData.importTargetRoutes = $scope.data.importConfiguration.importParameters[0].importTargetRoutes
							.map(routeIdentifierObject => routeIdentifierObject.routeIdentifier)
							.join();
					}
					if ($scope.data.importConfiguration.importParameters[0].externalRefField) {
						$scope.formData.isExternalRefField = true;
					}
					if ($scope.data.importConfiguration.importParameters[0].driverControllerCodeField) {
						$scope.formData.isDriverControllerCodeField = true;
					}
				}

				if ($scope.data.importConfiguration.configurationFtpList === undefined || $scope.data.importConfiguration.configurationFtpList.length === 0) {
					$scope.data.importConfiguration.configurationFtpList = [];
				} else {
					$scope.status.isConfiguration = true;
				}

				if ($scope.data.importConfiguration.configurationUrlList === undefined || $scope.data.importConfiguration.configurationUrlList.length === 0) {
					$scope.data.importConfiguration.configurationUrlList = [];
				} else {
					$scope.status.isConfiguration = true;
				}

				if ($scope.data.importConfiguration.recipients === undefined || $scope.data.importConfiguration.recipients === 0) {
					$scope.data.importConfiguration.recipients = [];
				}
			}

			let recipientModal;
			let configurationFtpBackup, configurationUrlBackup, recipientBackup;

			AdminClientsService.getCurrentClient().then((client) => {
				$scope.data.sncf = client.sncf;

				if (!$scope.data.importConfiguration.id) {
					$scope.formData.routeMerge = client.routeMerge;
					$scope.formData.splitCharacter = client.splitCharacter;
					$scope.formData.ignoreCommercialPoints = client.ignoreCommercialPoints;
					$scope.formData.linePrefixToRemove = client.linePrefixToRemove;
					$scope.formData.commercialPointPrefixToRemove = client.commercialPointIdPrefixToRemove;
					$scope.formData.quayIdPrefixToRemove = client.quayIdPrefixToRemove;
					$scope.formData.stopAreaPrefixToRemove = client.stopAreaPrefixToRemove;
				}
			});

			$scope.getImportForm = function() {
				switch($scope.data.importConfiguration.importParameters[0].importType) {
					case 'GTFS': return $scope.importFormGtfs;
					case 'NEPTUNE': return $scope.importFormNeptune;
					case 'NETEX': return $scope.importFormNetex;
					default: return null;
				}
			};

			$scope.onImportTypeChange = function(importType) {
				$scope.formData.keepStopNames = importType === "GTFS" ? "false" : "true";
			};

			// Fonctions communes
			$scope.openCleanModeWarningModal = function() {
				Utils.openModal($uibModal, "cleanRepositoryWarning.html", $scope);
			};

			$scope.openKeepStopNamesWarningModal = function() {
				Utils.openModal($uibModal, "keepStopNamesWarning.html", $scope);
			};

			$scope.openBoardingAlightingWarningModal = function(){
				Utils.openModal($uibModal, "boardingAlightingWarning.html", $scope);
			};

			$scope.openKeepStopGeolocalisationModal = function(){
				Utils.openModal($uibModal, "keepStopGeolocalisation.html", $scope);
			};

			$scope.openUseTargetNetworkModal = function(){
				Utils.openModal($uibModal, "useTargetNetwork.html", $scope);
			};

			$scope.openRenameRoutesModal = function(){
				Utils.openModal($uibModal, "renameRoutesAfterMerge.html", $scope);
			};

			$scope.openImportFareFilesModal = function(){
				Utils.openModal($uibModal, "importFareFiles.html", $scope);
			};

			$scope.openRecomputeStopPlacesLocationModal = function(){
				Utils.openModal($uibModal, "recomputeStopPlacesLocationModal.html", $scope);
			};

			$scope.openValidationExportScheduleModal = function() {
				Utils.openModal($uibModal, "validationExportSchedule.html", $scope);
			};

			$scope.openPreviewPage = function (type,form,  importData, formData) {
				if (formData.cleanMode === null){
					Utils.openModal($uibModal, "cleanRepositoryWarning.html", $scope);
					return;
				}

				SharedProperties.setAttribute("fileName",importData.file.name);
				SharedProperties.setAttribute("fileDescription",formData.description);
				SharedProperties.setAttribute("routeMerge",formData.routeMerge);
				SharedProperties.setAttribute("generateMapMatching",formData.generateMapMatching);
				SharedProperties.setAttribute("routeSortOrder",formData.routeSortOrder);
				SharedProperties.setAttribute("netexImportLayouts",importData.netexImportLayouts);
				SharedProperties.setAttribute("netexImportColors",importData.netexImportColors);
				SharedProperties.setAttribute("splitCharacter",formData.splitCharacter);
				SharedProperties.setAttribute("linePrefixToRemove",formData.linePrefixToRemove);
				SharedProperties.setAttribute("commercialPointPrefixToRemove",formData.commercialPointPrefixToRemove);
				SharedProperties.setAttribute("quayIdPrefixToRemove",formData.quayIdPrefixToRemove);
				SharedProperties.setAttribute("importData",importData);
				SharedProperties.setAttribute("type",type);
				SharedProperties.setAttribute("analysisLaunchTime",new Date());
				SharedProperties.setAttribute("analysisDate",new Date());
				SharedProperties.setAttribute("importName",formData.name);
				SharedProperties.setAttribute("ignoreCommercialPoints",formData.ignoreCommercialPoints);
				SharedProperties.setAttribute("areaCentroidPrefixToRemove",formData.areaCentroidPrefixToRemove);
				SharedProperties.setAttribute("stopAreaPrefixToRemove",formData.stopAreaPrefixToRemove);
				SharedProperties.setAttribute("keepBoardingAlightingPossibility",formData.keepBoardingAlightingPossibility);
				SharedProperties.setAttribute("keepStopGeolocalisation",formData.keepStopGeolocalisation);
				SharedProperties.setAttribute("cleanMode",formData.cleanMode);
				SharedProperties.setAttribute("updateStopAccessibility", formData.updateStopAccessibility);
				SharedProperties.setAttribute("keepStopNames",	$scope.data.keepStopNames);
				SharedProperties.setAttribute("removeParentStations",	$scope.data.removeParentStations);
				SharedProperties.setAttribute("importShapesFile",	$scope.data.importShapesFile);
				SharedProperties.setAttribute("railUICprocessing",	$scope.data.railUICprocessing);
				SharedProperties.setAttribute("distanceGeolocation",	$scope.data.distanceGeolocation);
				SharedProperties.setAttribute("useTargetNetwork", formData.useTargetNetwork);
				SharedProperties.setAttribute("targetNetwork", formData.targetNetwork);
				SharedProperties.setAttribute("renameRoutesAfterMerge", formData.renameRoutesAfterMerge);
				SharedProperties.setAttribute("recomputeStopPlacesLocation", formData.recomputeStopPlacesLocation);
				SharedProperties.setAttribute("allowNonStandardGtfs", formData.allowNonStandardGtfs);
				SharedProperties.setAttribute("fillMissingStopName", formData.fillMissingStopName);
				SharedProperties.setAttribute("fillMissingCoordinates", formData.fillMissingCoordinates);
				SharedProperties.setAttribute("overwriteLineInformation", formData.overwriteLineInformation);
				SharedProperties.setAttribute("allowGtfsFlex", formData.allowGtfsFlex);
				SharedProperties.setAttribute("externalRefField", formData.externalRefField);
				SharedProperties.setAttribute("driverControllerCodeField", formData.driverControllerCodeField);

				// complete importData with formData to launch analysis

				importData.cleanMode = formData.cleanMode;
				importData.description = formData.description;
				importData.routeMerge = formData.routeMerge;
				importData.linePrefixToRemove = formData.linePrefixToRemove;
				importData.stopAreaPrefixToRemove = formData.stopAreaPrefixToRemove;
				importData.quayIdPrefixToRemove = formData.quayIdPrefixToRemove;
				importData.commercialPointPrefixToRemove = formData.commercialPointPrefixToRemove;
				importData.keepBoardingAlightingPossibility = formData.keepBoardingAlightingPossibility;
				importData.keepStopGeolocalisation = formData.keepStopGeolocalisation;
				importData.keepStopNames = formData.keepStopNames;
				importData.removeParentStations = formData.removeParentStations;
				importData.importShapesFile = formData.importShapesFile;
				importData.updateStopAccessibility = formData.updateStopAccessibility;
				importData.railUICprocessing = $scope.data.railUICprocessing;
				importData.distanceGeolocation = formData.distanceGeolocation;
				importData.ignoreCommercialPoints = formData.ignoreCommercialPoints;
				importData.areaCentroidPrefixToRemove = formData.areaCentroidPrefixToRemove;
				importData.splitCharacter = formData.splitCharacter;
				importData.routesReorganization = formData.routesReorganization;
				importData.useTargetNetwork = formData.useTargetNetwork;
				importData.targetNetwork = formData.targetNetwork;
				importData.renameRoutesAfterMerge = formData.renameRoutesAfterMerge;
				importData.netexImportColors = formData.netexImportColors;
				importData.netexImportLayouts = formData.netexImportLayouts;
				importData.routeSortOrder = formData.routeSortOrder;
				importData.generateMapMatching = formData.generateMapMatching;
				importData.importFareFiles = formData.importFareFiles;
				importData.recomputeStopPlacesLocation = formData.recomputeStopPlacesLocation;
				importData.importTargetRoutes = formData.importTargetRoutes;
				importData.allowNonStandardGtfs = formData.allowNonStandardGtfs;
				importData.fillMissingStopName = formData.fillMissingStopName;
				importData.fillMissingCoordinates = formData.fillMissingCoordinates;
				importData.overwriteLineInformation = formData.overwriteLineInformation;
				importData.allowGtfsFlex = formData.allowGtfsFlex;
				importData.externalRefField = formData.externalRefField;
				importData.driverControllerCodeField = formData.driverControllerCodeField;

				launchAnalysis(type,importData);
			};

			function launchAnalysis(type, importData) {

				if (type === "netex"){
					type = "netexprofile";
				}

				AdminClientsService.getReferentialIdAndUser().then((referential) => {
					AdminClientsService.getCurrentClient().then((client) => {
						importData = OpenImportsService.feedImportData(importData,client);
						OpenImportsService.postAnalyze(type, importData, referential.id, referential.user)
							.then(() => {
								toastr.success("", "Analyse démarrée");
								$location.path("data-management/imports/preview");
							}).catch((error) => {
								const data = error.data;
								if (data instanceof Blob){
									let reader = new FileReader();
									reader.onload = function() {
										var contenu = reader.result;
										let jsonResponse = angular.fromJson(contenu);
										toastr.error(jsonResponse.message);
									};
									reader.readAsText(data);
								}else{
									toastr.error(data ? data.message : "", "Problème lors de l'analyse");
								}
							});
					});
				});
			}

			// Fonction unifiée pour lancer l'analyse
			$scope.launchImport = function(type, form, importData, formData) {
				if (formData.cleanMode === null) {
					Utils.openModal($uibModal, "cleanRepositoryWarning.html", $scope);
					return;
				}

				// Configuration pour import automatique
				if ($scope.data.automaticImportConfiguration) {
					this.saveImportConfiguration(formData);
					return;
				}

				// Configuration pour import manuel
				this.openPreviewPage(type, form, importData, formData);
			};

			/**
			 * Calcul du cron
			 */

			let calculateCronImportConfiguration = function (activated) {
				if (!activated || $scope.data.importConfigurationSchedulerDate === undefined
					|| $scope.data.importConfigurationSchedulerDate.time === undefined) {
					return "";
				}

				let dayOfWeek = "";
				if ($scope.data.importConfigurationSchedulerDate.monday) {
					dayOfWeek += "2";
				}
				if ($scope.data.importConfigurationSchedulerDate.tuesday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "3";
				}
				if ($scope.data.importConfigurationSchedulerDate.wednesday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "4";
				}
				if ($scope.data.importConfigurationSchedulerDate.thursday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "5";
				}
				if ($scope.data.importConfigurationSchedulerDate.friday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "6";
				}
				if ($scope.data.importConfigurationSchedulerDate.saturday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "7";
				}
				if ($scope.data.importConfigurationSchedulerDate.sunday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "1";
				}

				if (dayOfWeek === "" ||
					isNaN($scope.data.importConfigurationSchedulerDate.time.getMinutes()) ||
					isNaN($scope.data.importConfigurationSchedulerDate.time.getHours())) {
					$scope.data.importConfiguration.activated = false;
					return "";
				}

				let minutes = $scope.data.importConfigurationSchedulerDate.time.getMinutes();
				let hours = $scope.data.importConfigurationSchedulerDate.time.getHours();

				return "0 "+ minutes + " " + hours + " * * " + dayOfWeek + " 2000-2099";
			};

			let calculateCronExportValidation = function () {
				if (!$scope.data.validationExportSchedulerDate || !$scope.data.validationExportSchedulerDate.time) {
					return "";
				}

				let dayOfWeek = "";
				if ($scope.data.validationExportSchedulerDate.monday) {
					dayOfWeek += "2";
				}
				if ($scope.data.validationExportSchedulerDate.tuesday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "3";
				}
				if ($scope.data.validationExportSchedulerDate.wednesday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "4";
				}
				if ($scope.data.validationExportSchedulerDate.thursday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "5";
				}
				if ($scope.data.validationExportSchedulerDate.friday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "6";
				}
				if ($scope.data.validationExportSchedulerDate.saturday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "7";
				}
				if ($scope.data.validationExportSchedulerDate.sunday) {
					dayOfWeek = addComma(dayOfWeek);
					dayOfWeek += "1";
				}

				if (dayOfWeek === "" ||
					isNaN($scope.data.validationExportSchedulerDate.time.getMinutes()) ||
					isNaN($scope.data.validationExportSchedulerDate.time.getHours())) {
					return "";
				}

				let minutes = $scope.data.validationExportSchedulerDate.time.getMinutes();
				let hours = $scope.data.validationExportSchedulerDate.time.getHours();

				return "0 "+ minutes + " " + hours + " * * " + dayOfWeek + " 2000-2099";
			};

			$scope.mapImportConfigFormData = function (formData){
				$scope.data.importConfiguration.importParameters[0].description = formData.description;
				$scope.data.importConfiguration.importParameters[0].importMode = formData.cleanMode;
				$scope.data.importConfiguration.importParameters[0].ignoreCommercialPoints = formData.ignoreCommercialPoints;
				$scope.data.importConfiguration.importParameters[0].linePrefixToRemove = formData.linePrefixToRemove;
				$scope.data.importConfiguration.importParameters[0].routeMerge = formData.routeMerge;
				$scope.data.importConfiguration.importParameters[0].splitCharacter = formData.splitCharacter;
				$scope.data.importConfiguration.importParameters[0].areaCentroidPrefixToRemove = formData.areaCentroidPrefixToRemove;
				$scope.data.importConfiguration.importParameters[0].stopAreaPrefixToRemove = formData.stopAreaPrefixToRemove;
				$scope.data.importConfiguration.importParameters[0].quayIdPrefixToRemove = formData.quayIdPrefixToRemove;
				$scope.data.importConfiguration.importParameters[0].commercialPointPrefixToRemove = formData.commercialPointPrefixToRemove;
				$scope.data.importConfiguration.importParameters[0].keepBoardingAlighting = formData.keepBoardingAlightingPossibility;
				$scope.data.importConfiguration.importParameters[0].keepStopGeolocalisation = formData.keepStopGeolocalisation;
				$scope.data.importConfiguration.importParameters[0].distanceGeolocation = formData.distanceGeolocation;
				$scope.data.importConfiguration.importParameters[0].keepStopNames = formData.keepStopNames;
				$scope.data.importConfiguration.importParameters[0].removeParentStations = formData.removeParentStations;
				$scope.data.importConfiguration.importParameters[0].updateStopAccessibility = formData.updateStopAccessibility;
				$scope.data.importConfiguration.importParameters[0].importShapesFile = formData.importShapesFile;
				$scope.data.importConfiguration.importParameters[0].routesReorganization = formData.routesReorganization;
				$scope.data.importConfiguration.importParameters[0].routeSortOrder = formData.routeSortOrder;
				$scope.data.importConfiguration.importParameters[0].netexImportLayouts = formData.netexImportLayouts;
				$scope.data.importConfiguration.importParameters[0].netexImportColors = formData.netexImportColors;
				$scope.data.importConfiguration.importParameters[0].useTargetNetwork = formData.useTargetNetwork;
				$scope.data.importConfiguration.importParameters[0].targetNetwork = formData.targetNetwork;
				$scope.data.importConfiguration.importParameters[0].renameRoutesAfterMerge = formData.renameRoutesAfterMerge;
				$scope.data.importConfiguration.importParameters[0].keepStopGeolocalisation = formData.keepStopGeolocalisation;
				$scope.data.importConfiguration.importParameters[0].updateStopAccessibility = formData.updateStopAccessibility;
				$scope.data.importConfiguration.importParameters[0].generateMapMatching = formData.generateMapMatching;
				$scope.data.importConfiguration.importParameters[0].importFareFiles = formData.importFareFiles;
				$scope.data.importConfiguration.importParameters[0].recomputeStopPlacesLocation = formData.recomputeStopPlacesLocation;
				$scope.data.importConfiguration.importParameters[0].allowNonStandardGtfs = formData.allowNonStandardGtfs;
				$scope.data.importConfiguration.importParameters[0].fillMissingStopName = formData.fillMissingStopName;
				$scope.data.importConfiguration.importParameters[0].fillMissingCoordinates = formData.fillMissingCoordinates;
				$scope.data.importConfiguration.importParameters[0].overwriteLineInformation = formData.overwriteLineInformation;
				$scope.data.importConfiguration.importParameters[0].allowGtfsFlex = formData.allowGtfsFlex;
				$scope.data.importConfiguration.importParameters[0].externalRefField = formData.externalRefField;
				$scope.data.importConfiguration.importParameters[0].driverControllerCodeField = formData.driverControllerCodeField;
				if (formData.importTargetRoutes && formData.importTargetRoutes.length > 0 && formData.importTargetRoutes.trim()) {
					$scope.data.importConfiguration.importParameters[0].importTargetRoutes = formData.importTargetRoutes
						.trim()
						.split(",")
						.map(routeId => {
							return {
								routeIdentifier: routeId
							}
						});
				} else {
					$scope.data.importConfiguration.importParameters[0].importTargetRoutes = [];
				}
			};

			// Fonction pour l'import automatique
			$scope.saveImportConfiguration = function(formData) {
				if ($scope.data.importConfiguration.configurationFtpList.dynamicFilename && $scope.isInvalidDynamicFilename()) {
					toastr.error("Le nom de fichier dynamique doit être une expression régulière valide se terminant par '.zip$' ou '.xml$'", "Erreur de format");
					return;
				}

				let cron = calculateCronImportConfiguration(true);
				if (cron !== "") {
					this.mapImportConfigFormData(formData);
					AdminImportConfigurationService.save($scope.data.importConfiguration)
						.then((response) => {
							this.editConfigurationImportConfiguration(cron, response.data);
							cron = calculateCronExportValidation();
							this.editConfigurationValidationExport(cron, response.data);
							toastr.success("", "Configuration sauvegardée");
							$location.path("/admin/import-configuration");
						})
						.catch((error) => {
							toastr.error(error.data?.message || "Erreur lors de la sauvegarde", "Erreur");
						});
				} else {
					toastr.error("Veuillez sélectionner au moins un jour d'application et définir un horaire", "Erreur");
				}
			};


			/*
			 * Récupère le nom du fichier uniquement
			 */
			$scope.getFileName = function (file) {
				return file.substring(file.lastIndexOf("/") + 1);
			};

			/*
			 * Lance le réimport du fichier
			 */
			$scope.reimportFile = function (fileName, description) {
				AdminClientsService.getReferentialIdAndUser().then((referential) => {
					OpenImportsService.postReimport($scope.getFileName(fileName), referential.id, referential.user, description)
						.then(() => {
							toastr.success("", "Import démarré");
							$location.path("data-management/imports/");
						}).catch((error) => {
							toastr.error(error.data ? error.data.message : "", "Problème lors de l'import");
						});
				});
			};

			/**
			 * Ouvre la modal d'édition des informations d'un import
			 */
			$scope.openReimportModal = function (reimportFileName) {
				$scope.data.reimportFileName = reimportFileName;
				Utils.openModal($uibModal, "reimport-infos.html", $scope);
			};

			$scope.editConfigurationFtp = function (isNewConfigurationFtp, configurationFtp) {
				$scope.status.isConfigurationEdit = true;
				$scope.data.isNewConfigurationFtp = isNewConfigurationFtp;
				configurationFtpBackup = angular.copy(configurationFtp);
				$scope.data.selectedConfigurationFtp = configurationFtp;
			};

			$scope.closeEditConfigurationFtp = function (keepChange) {
				$scope.status.isConfigurationEdit = false;
				if (keepChange) {
					if ($scope.data.selectedConfigurationFtp.id === undefined) {
						$scope.data.importConfiguration.configurationFtpList.splice(0, $scope.data.importConfiguration.configurationFtpList.length);
						$scope.data.importConfiguration.configurationFtpList.push($scope.data.selectedConfigurationFtp);
						$scope.status.isConfiguration = true;
					} else {
						$scope.data.importConfiguration.configurationFtpList.splice(0, $scope.data.importConfiguration.configurationFtpList.length);
						$scope.data.importConfiguration.configurationFtpList.push($scope.data.selectedConfigurationFtp);
						$scope.status.isConfiguration = true;
					}
				} else {
					if ($scope.data.selectedConfigurationFtp.id !== undefined) {
						$scope.data.importConfiguration.configurationFtpList.splice(0, $scope.data.importConfiguration.configurationFtpList.length);
					}
					if (configurationFtpBackup !== undefined) {
						$scope.data.importConfiguration.configurationFtpList.splice(0, $scope.data.importConfiguration.configurationFtpList.length);
						$scope.data.importConfiguration.configurationFtpList.push(configurationFtpBackup);
					}
				}
			};

			$scope.removeConfigurationFtp = () => {
				$scope.status.isConfiguration = false;
				$scope.data.importConfiguration.configurationFtpList.splice(0, $scope.data.importConfiguration.configurationFtpList.length);
			};


			// Gestion des configurations URL

			$scope.editConfigurationUrl = function (isNewConfigurationUrl, configurationUrl) {
				$scope.status.isConfigurationEdit = true;
				$scope.data.isNewConfigurationUrl = isNewConfigurationUrl;
				configurationUrlBackup = angular.copy(configurationUrl);
				$scope.data.selectedConfigurationUrl = configurationUrl;
			};

			$scope.closeEditConfigurationUrl = function (keepChange) {
				$scope.status.isConfigurationEdit = false;
				if (keepChange) {
					$scope.data.importConfiguration.configurationUrlList.splice(0, $scope.data.importConfiguration.configurationUrlList.length);
					$scope.data.importConfiguration.configurationUrlList.push($scope.data.selectedConfigurationUrl);
					$scope.status.isConfiguration = true;
				} else {
					$scope.data.importConfiguration.configurationUrlList.splice(0, $scope.data.importConfiguration.configurationUrlList.length);
					$scope.data.importConfiguration.configurationUrlList.push(configurationUrlBackup);
				}
			};

			$scope.removeConfigurationUrl = () => {
				$scope.data.importConfiguration.configurationUrlList.splice(0, $scope.data.importConfiguration.configurationUrlList.length);
				$scope.status.isConfiguration = false;
			};


			// Gestion des destinataires e-mail

			$scope.editRecipient = function (isNewRecipient, recipient) {
				$scope.data.isNewRecipient = isNewRecipient;
				recipientBackup = angular.copy(recipient);
				$scope.data.selectedRecipient = recipient;
				recipientModal = Utils.openModal($uibModal, "editRecipientModal.html", $scope);
			};

			$scope.newRecipient = function (isNewRecipient) {
				$scope.data.isNewRecipient = isNewRecipient;
				$scope.data.selectedRecipient = {};
				recipientModal = Utils.openModal($uibModal, "editRecipientModal.html", $scope);
			};

			$scope.closeEditRecipient = function (keepChange) {
				recipientModal.close();
				if (keepChange) {
					if ($scope.data.selectedRecipient.id === undefined) {
						$scope.data.importConfiguration.recipients.push($scope.data.selectedRecipient);
					} else {
						$scope.data.importConfiguration.recipients.splice($scope.data.importConfiguration.recipients.indexOf(c => c.id === $scope.data.selectedRecipient.id));
						$scope.data.importConfiguration.recipients.push($scope.data.selectedRecipient);
					}
				} else {
					if ($scope.data.selectedRecipient.id !== undefined) {
						$scope.data.importConfiguration.recipients.splice($scope.data.importConfiguration.recipients.indexOf(c => c.id === $scope.data.selectedRecipient.id));
					}
					if (recipientBackup !== undefined) {
						$scope.data.importConfiguration.recipients.push(recipientBackup);
					}
				}
			};

			$scope.removeRecipient = (recipient) => {
				$scope.data.importConfiguration.recipients = $scope.data.importConfiguration.recipients.filter(c => c.id !== recipient.id);
			};

			/**
			 * Lance un appel vers l'api pour persister les changements sur la configuration des imports automatiques
			 * @param apiCall Fonction d'appel vers l'api
			 * @param operationLabel Nom de l'opération
			 * @param onSuccess Fonction callback sur succès
			 */
			$scope.apiPersist = (apiCall, operationLabel, onSuccess) => {
				apiCall().then(() => {
					if (angular.isFunction(onSuccess)) {
						onSuccess();
					}
					toastr.success("", operationLabel + " réussie");
					$location.path("/admin/import-configuration");
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Erreur lors de la " + operationLabel;
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			};


			/**
			 * Edition du cron de l'import automatique
			 *
			 */
			$scope.editConfigurationImportConfiguration = function (cron, importConfiguration) {
				AdminClientsService.getReferentialIdAndUser().then((referential) => {
					AdminImportConfigurationService.updateImportConfigurationScheduler(referential.id, cron, importConfiguration.id, importConfiguration.importParameters[0].importType)
						.then(() => parseCron())
						.catch(() => {
							toastr.error("Problème lors de la mise à jour de la configuration des imports automatiques.", "Erreur");
						});
				});
			};

			/**
			 * Edition du cron de la validation/export
			 *
			 */
			$scope.editConfigurationValidationExport = function (cron, importConfiguration) {
				if (cron === "") {
					return;
				}
				AdminClientsService.getReferentialIdAndUser().then((referential) => {
					AdminImportConfigurationService.updateValidationExportScheduler(referential.id, cron, importConfiguration.id, importConfiguration.importParameters[0].importType)
					   .then(() => parseCron())
					   .catch(() => {
						   toastr.error("Problème lors de la mise à jour de la configuration des imports automatiques.", "Erreur");
					   });
				});
			};

			/**
			 * Suppression du cron de l'import automatique & validation/export
			 *
			 */
			$scope.deleteConfigurationImportConfiguration = function (id) {
				AdminClientsService.getReferentialIdAndUser().then((referential) => {
					AdminImportConfigurationService.deleteImportConfigurationScheduler(referential.id, id)
						.then(() => {})
						.catch(() => toastr.error("Problème lors de la suppression de l'import automatique.", "Erreur"));
					AdminImportConfigurationService.deleteValidationExportScheduler(referential.id, id)
					    .then(() => {})
						.catch(() => toastr.error("Problème lors de la suppression de l'import automatique.", "Erreur"));
				});
			};


			function addComma(dayOfWeek) {
				if (dayOfWeek !== "") {
					dayOfWeek += ",";
				}
				return dayOfWeek;
			}

			function parseCron() {
				if($scope.data.importConfiguration.id !== undefined){
					AdminClientsService.getReferentialIdAndUser().then((referential) => {
						AdminImportConfigurationService.getImportConfigurationCron(referential.id, $scope.data.importConfiguration.id).then((response) => {
							let data = response.data;
							$scope.data.importConfigurationSchedulerDate = {};
							$scope.data.importConfigurationSchedulerDate.time = new Date();
							if (data !== "") {
								$scope.data.importConfigurationSchedulerDate.time.setMilliseconds(0);
								$scope.data.importConfigurationSchedulerDate.time.setSeconds(0);
								$scope.data.importConfigurationSchedulerDate.time.setMinutes(data.minutes);
								$scope.data.importConfigurationSchedulerDate.time.setHours(data.hours);
								parseApplicationDays(data.applicationDays);
							} else {
								if ($scope.data.importConfiguration !== undefined) {
									$scope.data.importConfiguration.activated = false;
								}
								$scope.data.importConfigurationSchedulerDate.time.setMilliseconds(undefined);
								$scope.data.importConfigurationSchedulerDate.time.setSeconds(undefined);
								$scope.data.importConfigurationSchedulerDate.time.setMinutes(undefined);
								$scope.data.importConfigurationSchedulerDate.time.setHours(undefined);
							}
						})
							.catch(function () {
								toastr.error("Problème pour récupérer les informations de la planification de la configuration des imports", "Erreur");
							});
					});
				}
			}

			function parseCronValidationExport() {
				if($scope.data.importConfiguration.id !== undefined){
					$scope.data.validationExportSchedulerDate = {};
					$scope.data.validationExportSchedulerDate.time = undefined;
					AdminClientsService.getReferentialIdAndUser().then((referential) => {
						AdminImportConfigurationService.getValidationExportCron(referential.id, $scope.data.importConfiguration.id).then((response) => {
							let data = response.data;
							if (data !== "") {
								if (
									angular.isArray(data.minutes) && data.minutes[0] !== ""
									&& angular.isArray(data.hour) && data.hour[0] !== ""
									&& angular.isArray(data.applicationDays)
								) {
									$scope.data.validationExportSchedulerDate.time = new Date();
									$scope.data.validationExportSchedulerDate.time.setMilliseconds(0);
									$scope.data.validationExportSchedulerDate.time.setSeconds(0);
									$scope.data.validationExportSchedulerDate.time.setMinutes(data.minutes);
									$scope.data.validationExportSchedulerDate.time.setHours(data.hours);
									parseApplicationDaysValidationExport(data.applicationDays);
								}
							}
						})
						   .catch(function () {
							   toastr.error("Problème pour récupérer les informations de la planification de la validation et l'export", "Erreur");
						   });
					});
				}
			}

			/**
			 * Parse applicationDays array<number> ([3,4,5]) and tick checkbox (e.g: wed,thur,fri)
			 *
			 * @param applicationDays
			 */
			function parseApplicationDays(applicationDays) {

				applicationDays.forEach(day => {
					let dayInt = parseInt(day);

					switch (dayInt) {
						case 1:
							$scope.data.importConfigurationSchedulerDate.sunday = true;
							break;
						case 2:
							$scope.data.importConfigurationSchedulerDate.monday = true;
							break;
						case 3:
							$scope.data.importConfigurationSchedulerDate.tuesday = true;
							break;
						case 4:
							$scope.data.importConfigurationSchedulerDate.wednesday = true;
							break;
						case 5:
							$scope.data.importConfigurationSchedulerDate.thursday = true;
							break;
						case 6:
							$scope.data.importConfigurationSchedulerDate.friday = true;
							break;
						case 7:
							$scope.data.importConfigurationSchedulerDate.saturday = true;
							break;
					}
				});
			}

		function parseApplicationDaysValidationExport(applicationDays) {

			applicationDays.forEach(day => {
				let dayInt = parseInt(day);

				switch (dayInt) {
					case 1:
						$scope.data.validationExportSchedulerDate.sunday = true;
						break;
					case 2:
						$scope.data.validationExportSchedulerDate.monday = true;
						break;
					case 3:
						$scope.data.validationExportSchedulerDate.tuesday = true;
						break;
					case 4:
						$scope.data.validationExportSchedulerDate.wednesday = true;
						break;
					case 5:
						$scope.data.validationExportSchedulerDate.thursday = true;
						break;
					case 6:
						$scope.data.validationExportSchedulerDate.friday = true;
						break;
					case 7:
						$scope.data.validationExportSchedulerDate.saturday = true;
						break;
				}
			});
		}

			parseCron();

			parseCronValidationExport();


			$scope.editConfigurationImportWorkflow = function (value) {
				// $scope.data.importConfiguration.workflow = value;
				// if($scope.data.importConfiguration.workflow === "IMPORT" || $scope.data.importConfiguration.workflow === "ANALYZE"){
				// 	$scope.data.importConfiguration.importParameters[0].generateMapMatching = "NONE";
				// }
				// La map définit l'état précédent pour chaque workflow
				const previousStateMap = {
					'EXPORT': 'VALIDATION',
					'VALIDATION': 'IMPORT',
					'IMPORT': 'ANALYZE',
					'ANALYZE': null // ou undefined, ou ''
				};

				// Si on clique sur le workflow déjà actif, on revient à l'état précédent
				if ($scope.data.importConfiguration.workflow === value) {
					$scope.data.importConfiguration.workflow = previousStateMap[value];
				} else {
					// Sinon, on applique le nouvel état
					$scope.data.importConfiguration.workflow = value;
				}

				// Si votre fonction avait des effets de bord, gardez-les ici
				if($scope.data.importConfiguration.workflow === "IMPORT" || $scope.data.importConfiguration.workflow === "ANALYZE"){
					$scope.data.importConfiguration.importParameters[0].generateMapMatching = "NONE";
				}

				if ($scope.data.importConfiguration.workflow !== 'EXPORT') {
					$scope.resetValidationExportSchedule();
				}
			};

			$scope.resetWorkflow = function() {
				$scope.data.importConfiguration.workflow = null;
			}

			$scope.resetValidationExportSchedule = function() {
				$scope.data.validationExportSchedulerDate.time = undefined;
				$scope.data.validationExportSchedulerDate.monday = false;
				$scope.data.validationExportSchedulerDate.tuesday = false;
				$scope.data.validationExportSchedulerDate.wednesday = false;
				$scope.data.validationExportSchedulerDate.thursday = false;
				$scope.data.validationExportSchedulerDate.friday = false;
				$scope.data.validationExportSchedulerDate.saturday = false;
				$scope.data.validationExportSchedulerDate.sunday = false;
			}

			$scope.isInvalidDescription = function() {
				return $scope.formData.description && $scope.formData.description.length > 255;
			}

			$scope.isInvalidDynamicFilename = function () {
				const config = $scope.data.selectedConfigurationFtp;

				if (!config || !config.dynamicFilename) {
					return false;
				}

				const filename = $scope.data.selectedConfigurationFtp ? $scope.data.selectedConfigurationFtp.filename : "";

				if (!filename) {
					return true;
				}

				try {
					const validEndRegex = /\.(zip|xml)\$?$/;
					new RegExp(filename);
					return !validEndRegex.test(filename);
				} catch (e) {
					return true;
				}
			};
		}


	]);
